module.exports = __webpack_public_path__ + "img/preview.e02bffcf.jpg";